module.exports = __webpack_public_path__ + "media/toolkits/block-4-image-d38c67a4.png";